/**
 * Replace variables in a template string with properties of an object
 * and executes the resulting string
 *
 * @param params
 * @returns {never}
 * @example:
 * const template = "${text} == 'Foo Boo'";
 * const result = template.evaluate({
 *   text: 'Foo Boo'
 * });
 * console.log(result);
 */
String.prototype.evaluate = function(this: string, params: object): boolean | string | null {
    const names = Object.keys(params);
    const values = Object.values(params);
    try {
        const expression = new Function(...names, `return \`${this}\`;`)(...values);
        return new Function("return " + expression)();
    } catch (e) {
        console.warn(e);
        if (e instanceof ReferenceError) {
            // fields specified in expression not found in object
            return null;
        }
        throw e;
    }
};
